export default function CTASection() {
  return (
    <section className="relative py-24 md:py-32 px-6 md:px-10 lg:px-16 overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20toned%20modern%20fulfillment%20workspace%20with%20neatly%20organized%20product%20packages%20on%20shelves%20soft%20ambient%20lighting%20through%20industrial%20windows%20clean%20minimalist%20aesthetic%20with%20warm%20beige%20concrete%20and%20wood%20tones%20professional%20logistics%20environment%20spacious%20and%20orderly%20no%20people&width=1800&height=800&seq=cta-v2-banner-2026&orientation=landscape"
          alt="YOYBUY Spreadsheet logistics"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/70 to-foreground-950/40"></div>

      {/* Content */}
      <div className="relative z-10 max-w-6xl mx-auto flex flex-col md:flex-row md:items-end md:justify-between gap-10">
        {/* Left: Title + Button */}
        <div className="flex flex-col gap-6">
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-none lowercase">
            yOYBUY<br />spreadsheet
          </h2>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-3 px-6 py-3.5 bg-background-50 text-foreground-900 rounded-full text-sm font-semibold hover:bg-background-100 transition-all w-fit whitespace-nowrap cursor-pointer group"
          >
            Открыть таблицу
            <span className="w-7 h-7 flex items-center justify-center bg-foreground-900 rounded-full group-hover:bg-foreground-800 transition-colors">
              <i className="ri-arrow-right-line text-background-50 text-sm"></i>
            </span>
          </a>
        </div>

        {/* Right: Description */}
        <div className="max-w-sm">
          <p className="text-background-50/80 text-sm md:text-base leading-relaxed">
            Получите доступ к полной системе закупок из Китая.
            Начните использовать YOYBUY Spreadsheet уже сегодня.
          </p>
        </div>
      </div>
    </section>
  );
}